import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export function createTagApi({ teamId, name, displayName, tagType, parentTagId }) {
  const url = endpoints.tag.organization;
  const body = {
    team: teamId
      ? {
          uuid: teamId,
        }
      : null,
    name,
    displayName,
    tagType,
    parentTag: parentTagId
      ? {
          uuid: parentTagId,
        }
      : null,
  };
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
}
